export default __webpack_public_path__ + "static/media/bg-d_1.f7ebd291.svg";